import i18n from '@/i18n';

const getHttpStatus = (error: unknown): number | undefined =>
	(error as { response?: { status?: number } })?.response?.status;

export const isInterviewOverlapError = (error: unknown): boolean =>
	getHttpStatus(error) === 409;

export const getInterviewOverlapErrorMessage = (): string =>
	i18n.global.t('errors.companyNeed.interview.overlap');
